import get from "lodash/get";

export default state => parseInt(get(state, "search.query.page")) || 1;
